/*
 * mh-konf-pdf-gate.js — Karten-Aufraeumer fuer WPC-Dielen und Terrassenplatten
 *
 * 29.09.2026: Die E-Mail-Abfrage vor dem PDF ist in assets/mh-konf-suite.js umgezogen
 * (Punkt 6 dort) und gilt jetzt fuer alle vier Konfiguratoren: E-Mail Pflicht, Newsletter-
 * Haekchen freiwillig. Diese Datei fragt nichts mehr ab - sie blendet nur noch den zweiten
 * Link "Detailplan öffnen" auf der Export-Karte aus. "Als PDF öffnen" loest nach der
 * E-Mail-Abfrage genau diesen Detailplan aus (siehe openExport in der Suite).
 */
(function () {
  'use strict';
  if (window.__mhPdfGate) return;
  window.__mhPdfGate = true;

  var ROOTS = ['#mhKonfRoot', '#mhWpcRoot'];
  var DETAIL_RE = /^\s*Detailplan/;

  function tidy() {
    ROOTS.forEach(function (sel) {
      var roots = document.querySelectorAll(sel);
      for (var r = 0; r < roots.length; r++) {
        var link = roots[r].querySelector('#shareLink');
        var card = link && link.closest('.extra');
        if (!card) continue;
        var as = card.querySelectorAll('a');
        for (var i = 0; i < as.length; i++) {
          var d = as[i];
          if (!DETAIL_RE.test(d.textContent || '') || d.getAttribute('data-mhpg-hidden')) continue;
          d.setAttribute('data-mhpg-hidden', '1');
          d.style.display = 'none';
          var br = d.previousElementSibling;
          if (br && br.tagName === 'BR') br.style.display = 'none';
        }
      }
    });
  }
  var tidyQ = false;
  function tidySoon() { if (tidyQ) return; tidyQ = true; setTimeout(function () { tidyQ = false; tidy(); }, 150); }

  function start() {
    tidy();
    if (window.MutationObserver) new MutationObserver(tidySoon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', tidy);
})();